export default __webpack_public_path__ + "static/media/Group 1285TataNeu.08003b6a.png";